import { Button, Popover, PopoverTrigger, Stack } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { TextCell } from '@common/components/TextCell';

import { VehicleDetailsContent } from '../order-details/VehicleDetailsSection';

interface VehicleCellProps {
	vehicleName: string;
	purchasedVehicleId: string;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	return (
		<div style={{ width: 360 }}>
			<Stack itemsSpacing='8'>
				<VehicleDetailsContent purchasedVehicleId={purchasedVehicleId} condensed />
			</Stack>
		</div>
	);
};

export const VehicleCell = ({ vehicleName, purchasedVehicleId }: VehicleCellProps) => {
	// PopoverContent only renders when popover is open, so the hook will only be called then
	return (
		<PopoverTrigger>
			<Button
				className='vehicle-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={vehicleName} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
